import "./Button.less";

import * as React from "react";
import { Redirect } from "react-router-dom";

import { IDisableableProps } from "lib/interfaces";
import { IBaseProps } from "lib/data/interfaces";


interface IButtonProps extends IBaseProps, IDisableableProps {
	destination?: string;
	tooltip?: string;
	size?: "small" | "medium" | "large";
	fit?: boolean;
	isWide?: boolean;
	hasBorder?: boolean;
	onClick?: (event: React.SyntheticEvent) => void | any | Promise<any>;
}

interface IButtonState {
	isDisabled: boolean;
	isNavigating: boolean;
}


export class Button extends React.Component<IButtonProps, IButtonState> {

	constructor(props: IButtonProps) {

		super(props);

		this.state = {
			isDisabled: false,
			isNavigating: false
		};
	}

	public setDisabled() {
		this.setState({ isDisabled: true });
	}

	public componentWillMount() {

		// Set As Disabled (If Necessary)
		this.setAsDisabled(this.props);
	}

	public componentWillReceiveProps(newProps: IButtonProps) {

		// Set As Disabled (If Necessary)
		this.setAsDisabled(newProps);

		// Set Navigation to False
		this.setState({ isNavigating: false });
	}

	public render() {

		// Define Class Name(s)
		const className = [
			"button",
			(this.state.isDisabled ? "button-disabled" : undefined),
			this.props.className
		].filter(v => v !== undefined && v !== null).join(" ");

		// Define Content Class Name(s)
		const contentClassName = [
			"button-content",
			`button-${(this.props.size ? this.props.size : "small")}`,
			(this.props.isWide ? "button-wide" : undefined),
			(this.props.hasBorder ? "button-border" : undefined),
			(this.props.fit ? "button-fit-contents" : undefined),
			this.props.className
		].filter(v => v !== undefined && v !== null).join(" ");

		// Check For Navigation
		if (!this.state.isNavigating) {

			return (

				<div className={className} onClick={this.onClick} title={(this.props.tooltip ? this.props.tooltip : undefined)} >

					<div className="button-mask" />

					<div className={contentClassName}>

						{this.props.children}

					</div>

				</div>
			);
		}
		else {

			return (

				<Redirect to={this.props.destination as string} push={true} exact={true} />
			);

		}
	}

	private setAsDisabled = (props: IButtonProps) => {

		// Check If Button Is Explicitly Disabled
		// Or If Button Is Disabled By Convention
		if (props.isDisabled
			|| (!props.destination && !props.onClick)) {

			// Disable Button
			this.setState({ isDisabled: true });
		}
	}

	private onClick = async (event: React.SyntheticEvent): Promise<any | void> => {

		// Check For Disabled Button
		if (!this.state.isDisabled) {

			// Check For Provided Click Handler
			if (this.props.onClick) {

				// Execute Click Handler
				const returnValue = await this.props.onClick(event);

				// Check For Return Value
				if (returnValue) {

					// Return The Value
					return returnValue;
				}
			}

			// Check For Destination
			if (this.props.destination) {

				// Indicate Navigation Is Occurring
				this.setState({ isNavigating: true });
			}
		}
	}
}
